import { render, staticRenderFns } from "./TalentMenu.vue?vue&type=template&id=78c5a7b4&scoped=true&lang=pug&"
import script from "./TalentMenu.vue?vue&type=script&lang=js&"
export * from "./TalentMenu.vue?vue&type=script&lang=js&"
import style0 from "./TalentMenu.vue?vue&type=style&index=0&id=78c5a7b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5a7b4",
  null
  
)

export default component.exports